import { useState } from "react";
import { Link } from "react-router-dom";
import { FOUNDER_PAGES } from "@/lib/access";
import { Seo } from "@/components/Seo";
import "./FounderHome.css";

const sections = [
  ["Finance & planning", ["cfo", "operations", "treasury", "close", "planning", "assets", "procurement", "contract-to-cash", "tax-compliance"]],
  ["Records & oversight", ["governance", "ownership", "secure-intake", "inbox"]],
  ["Activity & preferences", ["time", "hours", "website-analytics", "profile"]],
];
const descriptions = {
  cfo: "Review cash, profitability, source gaps, and your weekly financial brief.",
  operations: "Create and review financial records through their approval workflows.",
  treasury: "Compare cash scenarios and the 13-week forecast.",
  close: "Review entity close status, evidence gaps, and period changes.",
  planning: "Review entity budgets, forecasts, and planning assumptions.",
  assets: "Review asset records, ownership evidence, and book values.",
  procurement: "Review purchasing, approvals, and payables for each entity.",
  "contract-to-cash": "Review contracts, billing, and collection status.",
  "tax-compliance": "Review tax records, deadlines, and evidence readiness.",
  governance: "Maintain risk, insurance, continuity, and stewardship registers.",
  ownership: "Record brands, intellectual property, domains, and supporting evidence.",
  "secure-intake": "Upload and organize business records; review releases to legal counsel.",
  inbox: "Read inquiries, review attachments, and update their review status.",
  time: "Record time, review activity suggestions, and confirm time entries.",
  hours: "Review weekly hours and your estimated hourly contribution value.",
  "website-analytics": "Review public page views, company exploration, and inquiries.",
  profile: "Manage your contact details, time zone, and preferred opening page.",
};

export default function FounderHome() {
  const [search, setSearch] = useState("");
  const pages = FOUNDER_PAGES.filter(([path,label]) => path !== "/founder/home" && `${label} ${descriptions[path.split('/').pop()]}`.toLowerCase().includes(search.trim().toLowerCase()));
  return <main className="founder-home">
    <Seo title="Founder Office" noindex />
    <header><p className="font-display text-[var(--gold-lite)]">Jennae Michelle Holdings</p><h1>Founder Office</h1><p>Open a workspace to review evidence, manage records, or take the next action.</p></header>
    <label className="founder-home-search">Find a tool<input type="search" className="founder-input" value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search finances, documents, time…" /></label>
    <p className="text-sm text-[var(--muted)]" role="status">{pages.length} sections{search ? " matching your search" : " available"}. Financial views identify missing sources and unverified information within each section.</p>
    {!pages.length && <button className="jmh-secondary" onClick={()=>setSearch("")}>Clear search</button>}
    {sections.map(([title,ids]) => { const matches = pages.filter(([path])=>ids.includes(path.split('/').pop())); return matches.length ? <section key={title} aria-label={title}><h2>{title}</h2><div className="founder-home-grid">{matches.map(([path,label])=><Link key={path} to={path} className="founder-home-tool"><h3>{label}</h3><p>{descriptions[path.split('/').pop()]}</p><span>Open workspace →</span></Link>)}</div></section> : null; })}
  </main>;
}
